import { ENV_VARS } from 'constants/environment.constants';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';

export interface IDataFeedJob {
  processId: string;
  jobId: string;
  createdAt: string;
}

export const getDataFeedJobs = async (): Promise<IDataFeedJob[]> => {
  try {
    const config = {
      url: 'v1/api/data-feeds/jobs',
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res?.data?.data ?? [];
  } catch (error) {
    console.error('Error fetching data feed jobs:', error);
    throw error;
  }
};

export const loadDataFeedToIncumbent = async (
  reportId: number,
  job: IDataFeedJob,
): Promise<any> => {
  try {
    const config = {
      url: 'v1/api/data-feeds/load',
      method: 'POST',
      baseURL: ENV_VARS.API_URL,
      data: {
        reportId,
        processId: job.processId,
        jobId: job.jobId,
        createdAt: job.createdAt,
      },
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res?.data;
  } catch (error) {
    console.error('Error loading data feed to incumbent:', error);
    throw error;
  }
};
